<template>
  <div class="patient-info">
    <div class="patient-title">
      <span class="title">患者信息</span>
      <span class="connect">
        <span @click="showConnect">关联</span>
        <i class="el-icon-arrow-right"/>
      </span>
    </div>
    <div class="patient-row">
      <div>
        <span class="key">姓名：</span>
        <span class="value">{{ currentMissionData?.name }}</span>
      </div>
      <div>
        <span class="key">年龄：</span>
        <span class="value">{{ currentMissionData?.age }}</span>
      </div>
      <div>
        <span class="key">性别：</span>
        <span class="value">{{ currentMissionData?.gender }}</span>
      </div>
    </div>
    <div class="patient-row">
      <div>
        <span class="key">主诉：</span>
        <span class="value">{{ currentMissionData?.mainComplaint }}</span>
      </div>
    </div>
    <my-dialog
      :dialog-carted="isShowDialog"
      :width="1080"
      title="病例查询"
      @confirmOk="isShowDialog=false"
    >
      <template #content>
        <div>
          <div>
            <el-form
              ref="form"
              :model="sizeForm"
              label-width="85px"
              label-position="left"
            >
              <div class="line-one">
                <el-form-item label="姓名：" class="name">
                  <el-input v-model="sizeForm.name"/>
                </el-form-item>
                <el-form-item label="年龄：" class="age" label-width="65px">
                  <el-input v-model="sizeForm.name"/>
                  <el-select v-model="sizeForm.region" placeholder="请选择单位">
                    <el-option label="周" value="week"/>
                    <el-option label="年" value="year"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="性别：" class="gender" label-width="65px">
                  <el-select v-model="sizeForm.region" placeholder="请选择单位">
                    <el-option label="男" value="male"/>
                    <el-option label="女" value="female"/>
                  </el-select>
                </el-form-item>
              </div>
              <div class="line-two">
                <el-form-item label="身份证：" class="identifier">
                  <el-input v-model="sizeForm.name"/>
                </el-form-item>
                <el-form-item label="联系电话：" class="phone" label-width="103px">
                  <el-input v-model="sizeForm.name"/>
                </el-form-item>
              </div>
              <div class="line-three">
                <el-form-item label="住址：" class="address">
                  <el-input v-model="sizeForm.name"/>
                </el-form-item>
                <el-form-item size="large" label-width="24px">
                  <el-button type="primary" class="search-button" @click="onSubmit">搜索</el-button>
                </el-form-item>
              </div>
            </el-form>
            <el-table border :data="tableData" style="width: 100%">
              <el-table-column
                align="center"
                prop="index"
                label="序号"
                width="60"
              />
              <el-table-column
                align="center"
                prop="realName"
                label="姓名"
                width="80"
              />
              <el-table-column
                align="center"
                prop="realName"
                label="年龄"
                width="80"
              />
              <el-table-column
                align="center"
                prop="realName"
                label="性别"
                width="80"
              />
              <el-table-column
                align="center"
                prop="realName"
                label="身份证"
                width="120"
              />
              <el-table-column
                align="center"
                prop="realName"
                label="联系电话"
                width="120"
              />
              <el-table-column
                align="center"
                prop="realName"
                label="住址"
              />
              <el-table-column
                align="center"
                prop="realName"
                label="就诊卡号"
                width="120"
              />
              <el-table-column
                align="center"
                prop="realName"
                label="过敏史"
                width="120"
              />
              <el-table-column
                align="center"
                prop="realName"
                label="就诊史"
                width="80"
              />
            </el-table>
          </div>
        </div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import MyDialog from "@components/customDialog/MyDialog";
import { mapState } from "vuex";

export default {
  name: "PatientInfo",
  components: {
    MyDialog
  },
  data() {
    return {
      isShowDialog: false,
      tableData: [],
      sizeForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        resource: "",
        desc: "",
      },
    };
  },
  computed: {
    ...mapState({
      currentList: "currentList"
    }),
    currentMissionData() {
      const id = this.$route.params.id * 1;
      return this.currentList.find(item => {
        return item.ambulanceId === id;
      });
    }
  },
  methods: {
    showConnect() {
      this.isShowDialog = true;
    },
    onSubmit() {
    }
  }
};
</script>

<style scoped lang="scss">
.patient-info {
  margin-bottom: 60px;
}

.patient-title {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.patient-row {
  display: flex;
  justify-content: space-between;
  margin: 15px 0;

  .key {
    font-size: 16px;
    color: #666666;
    margin-right: 6px;
  }

  .value {
    font-size: 16px;
    color: #333333;
  }
}

.el-form ::v-deep {
  input.el-input__inner {
    height: 32px;
    border: 1px solid #999999;
    border-radius: 10px;
  }

  .line-three,
  .line-two,
  .line-one {
    display: flex;
  }

  .name .el-form-item__content {
    width: 120px;
    margin-right: 50px;
  }

  .age .el-form-item__content {
    display: flex;
    align-items: center;
    width: 176px;
    margin-right: 50px;
  }

  .age {
    .el-input {
      margin-right: 16px;
    }
  }

  .gender .el-form-item__content {
    width: 80px;
  }

  .identifier .el-form-item__content {
    width: 220px;
    margin-right: 50px;
  }

  .phone .el-form-item__content {
    width: 232px;
  }

  .address .el-form-item__content {
    width: 606px;
  }

  .search-button {
    width: 64px;
    height: 32px;
    border: 1px solid #75B8E6;
    border-radius: 8px;
    padding: 0;
    background: #fbfbfb;
    color: #75B8E6;
    font-size: 16px;
  }
}
</style>
